import { QRCodeTemplateData } from "@/components/QRCode/QRCodeTemplate";
import DeviceService from "@/services/devices";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const QrCodeTemplate: React.FC = () => {
    const { deviceId } = useParams<{ deviceId: string }>();
    const [qrCodes, setQrCodes] = useState([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const getQrData = async () => {
        if (!deviceId) return;
        setLoading(true);
        setError(null);
        try {
            const deviceService = new DeviceService();
            const response = await deviceService.getQrCodes(deviceId);
            if (response.error_message) {
                setError(response.error_message);
                return;
            }
            if (Array.isArray(response?.qr_codes)) {
                setQrCodes(response.qr_codes);
            } else {
                setError('Failed to fetch QR code data.');
            }
        } catch (err) {
            setError('Failed to fetch QR code data.');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getQrData();
    }, [deviceId]);

    return (
        <QRCodeTemplateData
            qrCodes={qrCodes}
            error={error}
            loading={loading}
        />
    );
};